import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { firebaseConnect, isLoaded, isEmpty } from 'react-redux-firebase';
import classNames from 'classnames';
// import { STORAGE } from '../../constants/index';
import { Loading } from '../../components';
import styles from './CollectionItem.module.scss';

// const myPath = process.env.PUBLIC_URL;

class CollectionItem extends Component {
  constructor(props) {
    super(props);
    this.imageContainer = React.createRef();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { collectionItem, isActive, index, currentId, history, isWip } = this.props;
    if (isActive !== prevProps.isActive && isActive) {
      if (index === currentId) {
        //this.createNewSessionID();
        if (isWip) {
          history.push(`/mediascape/${collectionItem.studioBookId}`);
        } else {
          history.push(`/mediascape/${collectionItem.studioBookId}`);
        }
      }
    }

    if (this.imageContainer.current) {
      const { returnItemSize } = this.props;
      if (returnItemSize) returnItemSize(this.imageContainer.current.offsetWidth);
    }
  }

  handleClick(id) {
    const { history, isWip } = this.props;

    if (isWip) {
      history.push(`/wip/${id}`);
    } else {
      history.push(`/mediascape/${id}`);
    }
  }

  fetchCoverImage(images, resourceId, useCF = false) {
    let activeImagePath;
    Object.keys(images).forEach(key => {
      if (useCF) {
        if (images[key].type === 'mediascapeteaser' && images[key].isActive) {
          // activeImagePath = `${STORAGE.cfPath}${resourceId}/images/splash.png`;
          activeImagePath = images[key].downloadURL;
        }
      } else {
        if (images[key].type === 'square' && images[key].isActive) {
          activeImagePath = images[key].downloadURL;
        }
      }
    });
    return activeImagePath;
  }

  render() {
    const { collectionItem, index, currentId, device, isWip } = this.props;

    if (isLoaded(collectionItem) && !isEmpty(collectionItem)) {
      // console.log('collectionItem', collectionItem, index, currentId);
      let activeImage = this.fetchCoverImage(collectionItem.images, collectionItem.studioBookId, device.isVZSTB);

      let clickId = isWip ? collectionItem.soundscapeId : collectionItem.studioBookId;
      return (
        <li
          className={classNames(styles.contentItem, {
            [styles.selected]: index === currentId,
          })}
          onClick={() => this.handleClick(clickId)}
          title={
            isWip
              ? `ssTitle: ${collectionItem.soundscapeTitle}\nrid: ${collectionItem.studioBookId}\nssid: ${collectionItem.soundscapeId}`
              : `${collectionItem.title}`
          }
        >
          {/* <div className={styles.title}>{collectionItem.title}</div> */}
          <div className={styles.title}>{collectionItem.title}</div>
          <div className={styles.imageContainer} ref={this.imageContainer}>
            <img className={styles.mediaImage} src={activeImage} alt={`book cover art for ${collectionItem.title}`} />
          </div>
        </li>
      );
    } else {
      return (
        <div className={styles.loadingWrap}>
          <Loading />
        </div>
      );
    }
  }
}
const enhance = compose(
  firebaseConnect(props => [
    {
      path: props.isWip ? `packagedMedia/v1/en-us/${props.id}` : `nfxMedia/v1/en-us/${props.id}`,
      storeAs: `${props.id}`,
    },
  ]),
  connect(
    // Map redux state to component props
    ({ firebase: { data }, device }, props) => ({
      collectionItem: data[props.id],
      device,
    }),
  ),
);

export default enhance(CollectionItem);
